export const Routes = {
  entitySettings: (entitySubdomain: string) => `/entity/${entitySubdomain}/settings`,
  budgeting: ({
    entitySubdomain,
    baseRouterPath = "/budgeting",
  }: {
    entitySubdomain: string;
    baseRouterPath?: string;
  }) => `${baseRouterPath}/${entitySubdomain}`,
  newRequest: ({
    entitySubdomain,
    formTypeId,
    baseRouterPath,
  }: {
    entitySubdomain: string;
    formTypeId: string;
    baseRouterPath?: string;
  }) => `${Routes.budgeting({ entitySubdomain, baseRouterPath })}/new_request/${formTypeId}`,
  newPerformanceKpiSubmission: ({
    entitySubdomain,
    baseRouterPath,
  }: {
    entitySubdomain: string;
    baseRouterPath?: string;
  }) => `${Routes.budgeting({ entitySubdomain, baseRouterPath })}/performance/new_submission`,
  migration: (entitySubdomain: string) => `/migration/${entitySubdomain}/view`,
  migrationView: (entitySubdomain: string, view: string) => `/migration/${entitySubdomain}/view#${view}`,
};
